import { PaginationFilters } from '../../../../../../shared/models/pagination-filters.model';
import { AppRootState } from '../../../../../../store/models/app-state.model';

export const getStatisticsPaginationFiltersSelector = (
  state: AppRootState
): PaginationFilters => {
  return state.appsFeature.statistics.pagination;
};
